export const CHARACTER_LIMIT: {
  [key in ScreenSizeType]: number
} = {
  xs: 10,
  sm: 15,
  md: 20,
  lg: 30,
  xl: 50,
  xxl: 70
}

export const BREAKPOINTS: {
  [key in ScreenSizeType]: ScreenResolutionType
} = {
  xs: 320,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1440,
  xxl: 1920
}
